"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "@/src/hooks/usePathname";
import { getBridge } from "@/src/lib/bridge/bridge";
import type { NativeStatusBarStyle } from "@/src/lib/bridge/types";
import { resolveNativeStatusBarStyle } from "@/src/utils/bridge/statusBarStylePolicy";

/**
 * App 内 pathname 变化时，同步原生状态栏样式（消息：set-status-bar-style）。
 */
export function useStatusBarStyleSync(): void {
  const pathname = usePathname();
  const lastSentStyleRef = useRef<NativeStatusBarStyle | null>(null);

  useEffect(() => {
    if (!getBridge().isInApp() || getBridge().getPlatform() === "android") {
      return;
    }

    const style = resolveNativeStatusBarStyle(pathname);
    if (lastSentStyleRef.current === style) {
      return;
    }

    lastSentStyleRef.current = style;
    getBridge().setStatusBarStyle(style);
  }, [pathname]);
}
